import getValue from "../get-value/phone";

const empty = /\+\d?$/;

export default function(value) {
  const number = getValue(value);
  return !number || empty.test(number);
}
